import { TradingTooltip } from '@trading-ui/core';
import React, { useState } from 'react';

type SidebarButtonProps = {
  Icon: React.ComponentType<{ color: string }>;
  action: () => void;
  active: boolean;
  label: string;
};

const getStyles = (): React.CSSProperties => ({
  border: 'none',
  borderRadius: '100%',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease, color 0.2s ease',
  padding: '0.5rem',
  width: '40px',
  height: '40px',
  backgroundColor: 'transparent',
});

export default function SidebarButton({ Icon, action, active, label }: SidebarButtonProps) {
  const [isHovered, setIsHovered] = useState(false);

  const iconColor = isHovered || active ? '  #00BDB9' : 'var(--palette-custom-darkBlueColors-0)';

  return (
    <TradingTooltip title={label} placement="right">
      <button
        type="button"
        onClick={action}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={getStyles()}>
        <Icon color={iconColor} />
      </button>
    </TradingTooltip>
  );
}
